import { UPDATE_LOADER } from './constants'

export const SetLoader = (dataLoading) => (dispatch) => {
  dispatch({
    type: UPDATE_LOADER,
    payload: dataLoading,
  })
}
